import {Component} from '@angular/core';
import {FieldType} from '@ngx-formly/core';

@Component({
  selector: 'formly-field-button',
  template: ` <input
      style="display:none"
      type="input"
      [formControl]="formControl"
      [formlyAttributes]="field"
    />
    <button
      *ngIf="props.actionsflow || props.status == 'RG'"
      type="button"
      [class]="props.class"
      style="cursor:pointer"
      [formlyAttributes]="field"
      (click)="onClick(formControl)"
    >
      {{ to.text }}
    </button>`,
})
export class FormlyFieldButton extends FieldType {
  onClick($event) {
    if (this.props.onClick) {
      this.props.onClick($event, this.model);
    }
  }
}
